<div class="date-input">
    <kendo-numerictextbox [ngClass]="{'disabled': isDisabled}" [disabled]="isDisabled" format="0#" [spinners]="false" [step]="0"
        (keypress)="limitInputLength($event, 2)" [(value)]="day" (change)="updateDay()">
    </kendo-numerictextbox>

    <span class="inline-separator mx-5">/</span>

    <kendo-numerictextbox [ngClass]="{'disabled': isDisabled}" [disabled]="isDisabled" format="0#" [spinners]="false" [step]="0"
        (keypress)="limitInputLength($event, 2)" [(value)]="month" (change)="updateMonth()"></kendo-numerictextbox>

    <span class="inline-separator mx-5">/</span>

    <kendo-numerictextbox [ngClass]="{'disabled': isDisabled}" [disabled]="isDisabled" format="#" [spinners]="false" [step]="0"
        (keypress)="limitInputLength($event, 4)" [(value)]="year" (change)="updateYear()" class="year"></kendo-numerictextbox>
</div>